import { render, staticRenderFns } from "./InstantMedication.vue?vue&type=template&id=7362d030&scoped=true"
import script from "./InstantMedication.vue?vue&type=script&lang=js"
export * from "./InstantMedication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7362d030",
  null
  
)

export default component.exports